module.exports = __webpack_public_path__ + "img/16_104.17a134a9.png";